// Auto-generated from config/theme_presets.json
// Light-mode CSS variable values for all 42 tweakcn themes.
// Used by DEMO mode to apply themes client-side via JS.

export type ThemeVars = Record<string, string>;
export type PresetsLight = Record<string, ThemeVars>;

export const PRESETS_LIGHT: PresetsLight = {
  'modern-minimal': {
    background: '#ffffff',
    foreground: '#333333',
    card: '#ffffff',
    'card-foreground': '#333333',
    popover: '#ffffff',
    'popover-foreground': '#333333',
    primary: '#3b82f6',
    'primary-foreground': '#ffffff',
    secondary: '#f3f4f6',
    'secondary-foreground': '#4b5563',
    muted: '#f9fafb',
    'muted-foreground': '#6b7280',
    accent: '#e0f2fe',
    'accent-foreground': '#1e3a8a',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#e5e7eb',
    input: '#e5e7eb',
    ring: '#3b82f6',
    'chart-1': '#3b82f6',
    'chart-2': '#2563eb',
    'chart-3': '#1d4ed8',
    'chart-4': '#1e40af',
    'chart-5': '#1e3a8a',
    radius: '0.375rem',
    sidebar: '#f9fafb',
    'sidebar-foreground': '#333333',
    'sidebar-primary': '#3b82f6',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#e0f2fe',
    'sidebar-accent-foreground': '#1e3a8a',
    'sidebar-border': '#e5e7eb',
    'sidebar-ring': '#3b82f6',
  },
  'violet-bloom': {
    background: '#fdfdfd',
    foreground: '#000000',
    card: '#fdfdfd',
    'card-foreground': '#000000',
    popover: '#fcfcfc',
    'popover-foreground': '#000000',
    primary: '#7033ff',
    'primary-foreground': '#ffffff',
    secondary: '#edf0f4',
    'secondary-foreground': '#080808',
    muted: '#f5f5f5',
    'muted-foreground': '#525252',
    accent: '#e2ebff',
    'accent-foreground': '#1e69dc',
    destructive: '#e54b4f',
    'destructive-foreground': '#ffffff',
    border: '#e7e7ee',
    input: '#ebebeb',
    ring: '#000000',
    'chart-1': '#4ac885',
    'chart-2': '#7033ff',
    'chart-3': '#fd822b',
    'chart-4': '#3276e4',
    'chart-5': '#747474',
    sidebar: '#f5f8fb',
    'sidebar-foreground': '#000000',
    'sidebar-primary': '#000000',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#ebebeb',
    'sidebar-accent-foreground': '#000000',
    'sidebar-border': '#ebebeb',
    'sidebar-ring': '#000000',
    radius: '1.4rem',
  },
  't3-chat': {
    background: '#faf5fa',
    foreground: '#501854',
    card: '#faf5fa',
    'card-foreground': '#501854',
    popover: '#ffffff',
    'popover-foreground': '#501854',
    primary: '#a84370',
    'primary-foreground': '#ffffff',
    secondary: '#f1c4e6',
    'secondary-foreground': '#77347c',
    muted: '#f6e5f3',
    'muted-foreground': '#834588',
    accent: '#f1c4e6',
    'accent-foreground': '#77347c',
    destructive: '#ab4347',
    'destructive-foreground': '#ffffff',
    border: '#efbdeb',
    input: '#e7c1dc',
    ring: '#db2777',
    'chart-1': '#d926a2',
    'chart-2': '#6c12b9',
    'chart-3': '#274754',
    'chart-4': '#e8c468',
    'chart-5': '#f4a462',
    sidebar: '#f3e4f6',
    'sidebar-foreground': '#ac1668',
    'sidebar-primary': '#454554',
    'sidebar-primary-foreground': '#faf1f7',
    'sidebar-accent': '#f8f8f7',
    'sidebar-accent-foreground': '#454554',
    'sidebar-border': '#eceae9',
    'sidebar-ring': '#db2777',
    radius: '0.5rem',
  },
  twitter: {
    background: '#ffffff',
    foreground: '#0f1419',
    card: '#f7f8f8',
    'card-foreground': '#0f1419',
    popover: '#ffffff',
    'popover-foreground': '#0f1419',
    primary: '#1e9df1',
    'primary-foreground': '#ffffff',
    secondary: '#0f1419',
    'secondary-foreground': '#ffffff',
    muted: '#E5E5E6',
    'muted-foreground': '#0f1419',
    accent: '#E3ECF6',
    'accent-foreground': '#1e9df1',
    destructive: '#f4212e',
    'destructive-foreground': '#ffffff',
    border: '#e1eaef',
    input: '#f7f9fa',
    ring: '#1da1f2',
    'chart-1': '#1e9df1',
    'chart-2': '#00b87a',
    'chart-3': '#f7b928',
    'chart-4': '#17bf63',
    'chart-5': '#e0245e',
    sidebar: '#f7f8f8',
    'sidebar-foreground': '#0f1419',
    'sidebar-primary': '#1e9df1',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#E3ECF6',
    'sidebar-accent-foreground': '#1e9df1',
    'sidebar-border': '#e1e8ed',
    'sidebar-ring': '#1da1f2',
    radius: '1.3rem',
  },
  'mocha-mousse': {
    background: '#F1F0E5',
    foreground: '#56453F',
    card: '#F1F0E5',
    'card-foreground': '#56453F',
    popover: '#FFFFFF',
    'popover-foreground': '#56453F',
    primary: '#A37764',
    'primary-foreground': '#FFFFFF',
    secondary: '#BAAB92',
    'secondary-foreground': '#ffffff',
    muted: '#E4C7B8',
    'muted-foreground': '#8A655A',
    accent: '#E4C7B8',
    'accent-foreground': '#56453F',
    destructive: '#1f1a17',
    'destructive-foreground': '#FFFFFF',
    border: '#BAAB92',
    input: '#BAAB92',
    ring: '#A37764',
    'chart-1': '#A37764',
    'chart-2': '#8A655A',
    'chart-3': '#C39E88',
    'chart-4': '#BAAB92',
    'chart-5': '#A28777',
    sidebar: '#ebd6cb',
    'sidebar-foreground': '#56453F',
    'sidebar-primary': '#A37764',
    'sidebar-primary-foreground': '#FFFFFF',
    'sidebar-accent': '#C39E88',
    'sidebar-accent-foreground': '#ffffff',
    'sidebar-border': '#A28777',
    'sidebar-ring': '#A37764',
    radius: '0.5rem',
  },
  bubblegum: {
    background: '#f6e6ee',
    foreground: '#5b5b5b',
    card: '#fdedc9',
    'card-foreground': '#5b5b5b',
    popover: '#ffffff',
    'popover-foreground': '#5b5b5b',
    primary: '#d04f99',
    'primary-foreground': '#ffffff',
    secondary: '#8acfd1',
    'secondary-foreground': '#333333',
    muted: '#b2e1eb',
    'muted-foreground': '#7a7a7a',
    accent: '#fbe2a7',
    'accent-foreground': '#333333',
    destructive: '#f96f70',
    'destructive-foreground': '#ffffff',
    border: '#d04f99',
    input: '#e4e4e4',
    ring: '#e670ab',
    'chart-1': '#e670ab',
    'chart-2': '#84d2e2',
    'chart-3': '#fbe2a7',
    'chart-4': '#f3a0ca',
    'chart-5': '#d7488e',
    sidebar: '#f8d8ea',
    'sidebar-foreground': '#333333',
    'sidebar-primary': '#ec4899',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#f9a8d4',
    'sidebar-accent-foreground': '#333333',
    'sidebar-border': '#f3e8ff',
    'sidebar-ring': '#ec4899',
    radius: '0.4rem',
  },
  'amethyst-haze': {
    background: '#f8f7fa',
    foreground: '#3d3c4f',
    card: '#ffffff',
    'card-foreground': '#3d3c4f',
    popover: '#ffffff',
    'popover-foreground': '#3d3c4f',
    primary: '#8a79ab',
    'primary-foreground': '#f8f7fa',
    secondary: '#dfd9ec',
    'secondary-foreground': '#3d3c4f',
    muted: '#dcd9e3',
    'muted-foreground': '#6b6880',
    accent: '#e6a5b8',
    'accent-foreground': '#4b2e36',
    destructive: '#d95c5c',
    'destructive-foreground': '#f8f7fa',
    border: '#cec9d9',
    input: '#eae7f0',
    ring: '#8a79ab',
    'chart-1': '#8a79ab',
    'chart-2': '#e6a5b8',
    'chart-3': '#77b8a1',
    'chart-4': '#f0c88d',
    'chart-5': '#a0bbe3',
    sidebar: '#f1eff5',
    'sidebar-foreground': '#3d3c4f',
    'sidebar-primary': '#8a79ab',
    'sidebar-primary-foreground': '#f8f7fa',
    'sidebar-accent': '#e6a5b8',
    'sidebar-accent-foreground': '#4b2e36',
    'sidebar-border': '#d7d2e0',
    'sidebar-ring': '#8a79ab',
    radius: '0.5rem',
  },
  notebook: {
    background: '#f9f9f9',
    foreground: '#3a3a3a',
    card: '#ffffff',
    'card-foreground': '#3a3a3a',
    popover: '#ffffff',
    'popover-foreground': '#3a3a3a',
    primary: '#606060',
    'primary-foreground': '#f0f0f0',
    secondary: '#dedede',
    'secondary-foreground': '#3a3a3a',
    muted: '#e3e3e3',
    'muted-foreground': '#505050',
    accent: '#f3eac8',
    'accent-foreground': '#5d4037',
    destructive: '#c87a7a',
    'destructive-foreground': '#ffffff',
    border: '#747272',
    input: '#ffffff',
    ring: '#a0a0a0',
    'chart-1': '#333333',
    'chart-2': '#555555',
    'chart-3': '#777777',
    'chart-4': '#999999',
    'chart-5': '#bbbbbb',
    sidebar: '#f0f0f0',
    'sidebar-foreground': '#3a3a3a',
    'sidebar-primary': '#606060',
    'sidebar-primary-foreground': '#f0f0f0',
    'sidebar-accent': '#f3eac8',
    'sidebar-accent-foreground': '#5d4037',
    'sidebar-border': '#c0c0c0',
    'sidebar-ring': '#a0a0a0',
    radius: '0.625rem',
  },
  'doom-64': {
    background: '#cccccc',
    foreground: '#1f1f1f',
    card: '#b0b0b0',
    'card-foreground': '#1f1f1f',
    popover: '#b0b0b0',
    'popover-foreground': '#1f1f1f',
    primary: '#b71c1c',
    'primary-foreground': '#ffffff',
    secondary: '#556b2f',
    'secondary-foreground': '#ffffff',
    muted: '#b8b8b8',
    'muted-foreground': '#4a4a4a',
    accent: '#4682b4',
    'accent-foreground': '#ffffff',
    destructive: '#ff6f00',
    'destructive-foreground': '#000000',
    border: '#505050',
    input: '#505050',
    ring: '#b71c1c',
    'chart-1': '#b71c1c',
    'chart-2': '#556b2f',
    'chart-3': '#4682b4',
    'chart-4': '#ff6f00',
    'chart-5': '#8d6e63',
    sidebar: '#b0b0b0',
    'sidebar-foreground': '#1f1f1f',
    'sidebar-primary': '#b71c1c',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#4682b4',
    'sidebar-accent-foreground': '#ffffff',
    'sidebar-border': '#505050',
    'sidebar-ring': '#b71c1c',
    radius: '0px',
  },
  catppuccin: {
    background: '#eff1f5',
    foreground: '#4c4f69',
    card: '#ffffff',
    'card-foreground': '#4c4f69',
    popover: '#ccd0da',
    'popover-foreground': '#4c4f69',
    primary: '#8839ef',
    'primary-foreground': '#ffffff',
    secondary: '#ccd0da',
    'secondary-foreground': '#4c4f69',
    muted: '#dce0e8',
    'muted-foreground': '#6c6f85',
    accent: '#04a5e5',
    'accent-foreground': '#ffffff',
    destructive: '#d20f39',
    'destructive-foreground': '#ffffff',
    border: '#bcc0cc',
    input: '#ccd0da',
    ring: '#8839ef',
    'chart-1': '#8839ef',
    'chart-2': '#04a5e5',
    'chart-3': '#40a02b',
    'chart-4': '#fe640b',
    'chart-5': '#dc8a78',
    sidebar: '#e6e9ef',
    'sidebar-foreground': '#4c4f69',
    'sidebar-primary': '#8839ef',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#04a5e5',
    'sidebar-accent-foreground': '#ffffff',
    'sidebar-border': '#bcc0cc',
    'sidebar-ring': '#8839ef',
    radius: '0.35rem',
  },
  graphite: {
    background: '#f0f0f0',
    foreground: '#333333',
    card: '#f5f5f5',
    'card-foreground': '#333333',
    popover: '#f5f5f5',
    'popover-foreground': '#333333',
    primary: '#606060',
    'primary-foreground': '#ffffff',
    secondary: '#e0e0e0',
    'secondary-foreground': '#333333',
    muted: '#d9d9d9',
    'muted-foreground': '#666666',
    accent: '#c0c0c0',
    'accent-foreground': '#333333',
    destructive: '#cc3333',
    'destructive-foreground': '#ffffff',
    border: '#d0d0d0',
    input: '#e0e0e0',
    ring: '#606060',
    'chart-1': '#606060',
    'chart-2': '#476666',
    'chart-3': '#909090',
    'chart-4': '#a8a8a8',
    'chart-5': '#c0c0c0',
    sidebar: '#eaeaea',
    'sidebar-foreground': '#333333',
    'sidebar-primary': '#606060',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#c0c0c0',
    'sidebar-accent-foreground': '#333333',
    'sidebar-border': '#d0d0d0',
    'sidebar-ring': '#606060',
    radius: '0.35rem',
  },
  perpetuity: {
    background: '#e8f0f0',
    foreground: '#0a4a55',
    card: '#f2f7f7',
    'card-foreground': '#0a4a55',
    popover: '#f2f7f7',
    'popover-foreground': '#0a4a55',
    primary: '#06858e',
    'primary-foreground': '#ffffff',
    secondary: '#d9eaea',
    'secondary-foreground': '#0a4a55',
    muted: '#e0eaea',
    'muted-foreground': '#427a7e',
    accent: '#c9e5e7',
    'accent-foreground': '#0a4a55',
    destructive: '#d13838',
    'destructive-foreground': '#ffffff',
    border: '#cde0e2',
    input: '#d9eaea',
    ring: '#06858e',
    'chart-1': '#06858e',
    'chart-2': '#1e9ea6',
    'chart-3': '#37b6be',
    'chart-4': '#5dc7ce',
    'chart-5': '#8ad8dd',
    sidebar: '#daebed',
    'sidebar-foreground': '#0a4a55',
    'sidebar-primary': '#06858e',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#c9e5e7',
    'sidebar-accent-foreground': '#0a4a55',
    'sidebar-border': '#cde0e2',
    'sidebar-ring': '#06858e',
    radius: '0.125rem',
  },
  'kodama-grove': {
    background: '#e4d7b0',
    foreground: '#5c4b3e',
    card: '#e7dbbf',
    'card-foreground': '#5c4b3e',
    popover: '#f3ead2',
    'popover-foreground': '#5c4b3e',
    primary: '#8d9d4f',
    'primary-foreground': '#fdfbf6',
    secondary: '#decea0',
    'secondary-foreground': '#5c4b3e',
    muted: '#decea0',
    'muted-foreground': '#85766a',
    accent: '#dbc894',
    'accent-foreground': '#5c4b3e',
    destructive: '#d98b7e',
    'destructive-foreground': '#faf8f2',
    border: '#b19681',
    input: '#dbc894',
    ring: '#9db18c',
    'chart-1': '#9db18c',
    'chart-2': '#8a9f7b',
    'chart-3': '#bac9b4',
    'chart-4': '#71856a',
    'chart-5': '#5e6e58',
    sidebar: '#e2d1a2',
    'sidebar-foreground': '#5c4b3e',
    'sidebar-primary': '#9db18c',
    'sidebar-primary-foreground': '#fdfbf6',
    'sidebar-accent': '#eae5d9',
    'sidebar-accent-foreground': '#5c4b3e',
    'sidebar-border': '#e5e0d4',
    'sidebar-ring': '#9db18c',
    radius: '0.425rem',
  },
  'cosmic-night': {
    background: '#f5f5ff',
    foreground: '#2a2a4a',
    card: '#ffffff',
    'card-foreground': '#2a2a4a',
    popover: '#ffffff',
    'popover-foreground': '#2a2a4a',
    primary: '#6e56cf',
    'primary-foreground': '#ffffff',
    secondary: '#e4dfff',
    'secondary-foreground': '#4a4080',
    muted: '#f0f0fa',
    'muted-foreground': '#6c6c8a',
    accent: '#d8e6ff',
    'accent-foreground': '#2a2a4a',
    destructive: '#ff5470',
    'destructive-foreground': '#ffffff',
    border: '#e0e0f0',
    input: '#e0e0f0',
    ring: '#6e56cf',
    'chart-1': '#6e56cf',
    'chart-2': '#9e8cfc',
    'chart-3': '#5d5fef',
    'chart-4': '#7c75fa',
    'chart-5': '#4740b3',
    radius: '0.5rem',
    sidebar: '#f0f0fa',
    'sidebar-foreground': '#2a2a4a',
    'sidebar-primary': '#6e56cf',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#d8e6ff',
    'sidebar-accent-foreground': '#2a2a4a',
    'sidebar-border': '#e0e0f0',
    'sidebar-ring': '#6e56cf',
  },
  tangerine: {
    background: '#e8ebed',
    foreground: '#333333',
    card: '#ffffff',
    'card-foreground': '#333333',
    popover: '#ffffff',
    'popover-foreground': '#333333',
    primary: '#e05d38',
    'primary-foreground': '#ffffff',
    secondary: '#f3f4f6',
    'secondary-foreground': '#4b5563',
    muted: '#f9fafb',
    'muted-foreground': '#6b7280',
    accent: '#d6e4f0',
    'accent-foreground': '#1e3a8a',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#dcdfe2',
    input: '#f4f5f7',
    ring: '#e05d38',
    'chart-1': '#86a7c8',
    'chart-2': '#eea591',
    'chart-3': '#5a7ca6',
    'chart-4': '#466494',
    'chart-5': '#334c82',
    sidebar: '#dddfe2',
    'sidebar-foreground': '#333333',
    'sidebar-primary': '#e05d38',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#d6e4f0',
    'sidebar-accent-foreground': '#1e3a8a',
    'sidebar-border': '#e5e7eb',
    'sidebar-ring': '#e05d38',
    radius: '0.75rem',
  },
  'quantum-rose': {
    background: '#fff0f8',
    foreground: '#91185c',
    card: '#fff7fc',
    'card-foreground': '#91185c',
    popover: '#fff7fc',
    'popover-foreground': '#91185c',
    primary: '#e6067a',
    'primary-foreground': '#ffffff',
    secondary: '#ffd6ff',
    'secondary-foreground': '#91185c',
    muted: '#ffe3f2',
    'muted-foreground': '#c04283',
    accent: '#ffc1e3',
    'accent-foreground': '#91185c',
    destructive: '#d13869',
    'destructive-foreground': '#ffffff',
    border: '#ffc7e6',
    input: '#ffd6ff',
    ring: '#e6067a',
    'chart-1': '#e6067a',
    'chart-2': '#c44b97',
    'chart-3': '#9969b6',
    'chart-4': '#7371bf',
    'chart-5': '#5e84ff',
    sidebar: '#ffedf6',
    'sidebar-foreground': '#91185c',
    'sidebar-primary': '#e6067a',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#ffc1e3',
    'sidebar-accent-foreground': '#91185c',
    'sidebar-border': '#ffddf0',
    'sidebar-ring': '#e6067a',
    radius: '0.5rem',
  },
  nature: {
    background: '#f8f5f0',
    foreground: '#3e2723',
    card: '#f8f5f0',
    'card-foreground': '#3e2723',
    popover: '#f8f5f0',
    'popover-foreground': '#3e2723',
    primary: '#2e7d32',
    'primary-foreground': '#ffffff',
    secondary: '#e8f5e9',
    'secondary-foreground': '#1b5e20',
    muted: '#f0e9e0',
    'muted-foreground': '#6d4c41',
    accent: '#c8e6c9',
    'accent-foreground': '#1b5e20',
    destructive: '#c62828',
    'destructive-foreground': '#ffffff',
    border: '#e0d6c9',
    input: '#e0d6c9',
    ring: '#2e7d32',
    'chart-1': '#4caf50',
    'chart-2': '#388e3c',
    'chart-3': '#2e7d32',
    'chart-4': '#1b5e20',
    'chart-5': '#0a1f0c',
    radius: '0.5rem',
    sidebar: '#f0e9e0',
    'sidebar-foreground': '#3e2723',
    'sidebar-primary': '#2e7d32',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#c8e6c9',
    'sidebar-accent-foreground': '#1b5e20',
    'sidebar-border': '#e0d6c9',
    'sidebar-ring': '#2e7d32',
  },
  'bold-tech': {
    background: '#ffffff',
    foreground: '#312e81',
    card: '#ffffff',
    'card-foreground': '#312e81',
    popover: '#ffffff',
    'popover-foreground': '#312e81',
    primary: '#8b5cf6',
    'primary-foreground': '#ffffff',
    secondary: '#f3f0ff',
    'secondary-foreground': '#4338ca',
    muted: '#f5f3ff',
    'muted-foreground': '#7c3aed',
    accent: '#dbeafe',
    'accent-foreground': '#1e40af',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#e0e7ff',
    input: '#e0e7ff',
    ring: '#8b5cf6',
    'chart-1': '#8b5cf6',
    'chart-2': '#7c3aed',
    'chart-3': '#6d28d9',
    'chart-4': '#5b21b6',
    'chart-5': '#4c1d95',
    radius: '0.625rem',
    sidebar: '#f5f3ff',
    'sidebar-foreground': '#312e81',
    'sidebar-primary': '#8b5cf6',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#dbeafe',
    'sidebar-accent-foreground': '#1e40af',
    'sidebar-border': '#e0e7ff',
    'sidebar-ring': '#8b5cf6',
  },
  'elegant-luxury': {
    background: '#faf7f5',
    foreground: '#1a1a1a',
    card: '#faf7f5',
    'card-foreground': '#1a1a1a',
    popover: '#faf7f5',
    'popover-foreground': '#1a1a1a',
    primary: '#9b2c2c',
    'primary-foreground': '#ffffff',
    secondary: '#fdf2d6',
    'secondary-foreground': '#805500',
    muted: '#f0ebe8',
    'muted-foreground': '#57534e',
    accent: '#fef3c7',
    'accent-foreground': '#7f1d1d',
    destructive: '#991b1b',
    'destructive-foreground': '#ffffff',
    border: '#f5e8d2',
    input: '#f5e8d2',
    ring: '#9b2c2c',
    'chart-1': '#b91c1c',
    'chart-2': '#9b2c2c',
    'chart-3': '#7f1d1d',
    'chart-4': '#b45309',
    'chart-5': '#92400e',
    radius: '0.375rem',
    sidebar: '#f0ebe8',
    'sidebar-foreground': '#1a1a1a',
    'sidebar-primary': '#9b2c2c',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#fef3c7',
    'sidebar-accent-foreground': '#7f1d1d',
    'sidebar-border': '#f5e8d2',
    'sidebar-ring': '#9b2c2c',
  },
  'amber-minimal': {
    background: '#ffffff',
    foreground: '#262626',
    card: '#ffffff',
    'card-foreground': '#262626',
    popover: '#ffffff',
    'popover-foreground': '#262626',
    primary: '#f59e0b',
    'primary-foreground': '#000000',
    secondary: '#f3f4f6',
    'secondary-foreground': '#4b5563',
    muted: '#f9fafb',
    'muted-foreground': '#6b7280',
    accent: '#fffbeb',
    'accent-foreground': '#92400e',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#e5e7eb',
    input: '#e5e7eb',
    ring: '#f59e0b',
    'chart-1': '#f59e0b',
    'chart-2': '#d97706',
    'chart-3': '#b45309',
    'chart-4': '#92400e',
    'chart-5': '#78350f',
    sidebar: '#f9fafb',
    'sidebar-foreground': '#262626',
    'sidebar-primary': '#f59e0b',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#fffbeb',
    'sidebar-accent-foreground': '#92400e',
    'sidebar-border': '#e5e7eb',
    'sidebar-ring': '#f59e0b',
    radius: '0.375rem',
  },
  supabase: {
    background: '#fcfcfc',
    foreground: '#171717',
    card: '#fcfcfc',
    'card-foreground': '#171717',
    popover: '#fcfcfc',
    'popover-foreground': '#525252',
    primary: '#72e3ad',
    'primary-foreground': '#1e2723',
    secondary: '#fdfdfd',
    'secondary-foreground': '#171717',
    muted: '#ededed',
    'muted-foreground': '#202020',
    accent: '#ededed',
    'accent-foreground': '#202020',
    destructive: '#ca3214',
    'destructive-foreground': '#fffcfc',
    border: '#dfdfdf',
    input: '#f6f6f6',
    ring: '#72e3ad',
    'chart-1': '#72e3ad',
    'chart-2': '#3b82f6',
    'chart-3': '#8b5cf6',
    'chart-4': '#f59e0b',
    'chart-5': '#10b981',
    sidebar: '#fcfcfc',
    'sidebar-foreground': '#707070',
    'sidebar-primary': '#72e3ad',
    'sidebar-primary-foreground': '#1e2723',
    'sidebar-accent': '#ededed',
    'sidebar-accent-foreground': '#202020',
    'sidebar-border': '#dfdfdf',
    'sidebar-ring': '#72e3ad',
    radius: '0.5rem',
  },
  'neo-brutalism': {
    background: '#ffffff',
    foreground: '#000000',
    card: '#ffffff',
    'card-foreground': '#000000',
    popover: '#ffffff',
    'popover-foreground': '#000000',
    primary: '#ff3333',
    'primary-foreground': '#ffffff',
    secondary: '#ffff00',
    'secondary-foreground': '#000000',
    muted: '#f0f0f0',
    'muted-foreground': '#333333',
    accent: '#0066ff',
    'accent-foreground': '#ffffff',
    destructive: '#000000',
    'destructive-foreground': '#ffffff',
    border: '#000000',
    input: '#000000',
    ring: '#ff3333',
    'chart-1': '#ff3333',
    'chart-2': '#ffff00',
    'chart-3': '#0066ff',
    'chart-4': '#00cc00',
    'chart-5': '#cc00cc',
    radius: '0px',
    sidebar: '#f0f0f0',
    'sidebar-foreground': '#000000',
    'sidebar-primary': '#ff3333',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#0066ff',
    'sidebar-accent-foreground': '#ffffff',
    'sidebar-border': '#000000',
    'sidebar-ring': '#ff3333',
  },
  'solar-dusk': {
    background: '#FDFBF7',
    foreground: '#4A3B33',
    card: '#F8F4EE',
    'card-foreground': '#4A3B33',
    popover: '#F8F4EE',
    'popover-foreground': '#4A3B33',
    primary: '#B45309',
    'primary-foreground': '#FFFFFF',
    secondary: '#E4C090',
    'secondary-foreground': '#57534E',
    muted: '#F1E9DA',
    'muted-foreground': '#78716C',
    accent: '#f2daba',
    'accent-foreground': '#57534E',
    destructive: '#991B1B',
    'destructive-foreground': '#FFFFFF',
    border: '#E4D9BC',
    input: '#E4D9BC',
    ring: '#B45309',
    'chart-1': '#B45309',
    'chart-2': '#78716C',
    'chart-3': '#A16207',
    'chart-4': '#78716C',
    'chart-5': '#CA8A04',
    radius: '0.3rem',
    sidebar: '#F1E9DA',
    'sidebar-foreground': '#4A3B33',
    'sidebar-primary': '#B45309',
    'sidebar-primary-foreground': '#FFFFFF',
    'sidebar-accent': '#A16207',
    'sidebar-accent-foreground': '#FFFFFF',
    'sidebar-border': '#E4D9BC',
    'sidebar-ring': '#B45309',
  },
  claymorphism: {
    background: '#e7e5e4',
    foreground: '#1e293b',
    card: '#f5f5f4',
    'card-foreground': '#1e293b',
    popover: '#f5f5f4',
    'popover-foreground': '#1e293b',
    primary: '#6366f1',
    'primary-foreground': '#ffffff',
    secondary: '#d6d3d1',
    'secondary-foreground': '#4b5563',
    muted: '#e7e5e4',
    'muted-foreground': '#6b7280',
    accent: '#f3e5f5',
    'accent-foreground': '#374151',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#d6d3d1',
    input: '#d6d3d1',
    ring: '#6366f1',
    'chart-1': '#6366f1',
    'chart-2': '#4f46e5',
    'chart-3': '#4338ca',
    'chart-4': '#3730a3',
    'chart-5': '#312e81',
    radius: '1.25rem',
    sidebar: '#d6d3d1',
    'sidebar-foreground': '#1e293b',
    'sidebar-primary': '#6366f1',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#f3e5f5',
    'sidebar-accent-foreground': '#374151',
    'sidebar-border': '#d6d3d1',
    'sidebar-ring': '#6366f1',
  },
  cyberpunk: {
    background: '#f8f9fa',
    foreground: '#0c0c1d',
    card: '#ffffff',
    'card-foreground': '#0c0c1d',
    popover: '#ffffff',
    'popover-foreground': '#0c0c1d',
    primary: '#ff00c8',
    'primary-foreground': '#ffffff',
    secondary: '#f0f0ff',
    'secondary-foreground': '#0c0c1d',
    muted: '#f0f0ff',
    'muted-foreground': '#0c0c1d',
    accent: '#00ffcc',
    'accent-foreground': '#0c0c1d',
    destructive: '#ff3d00',
    'destructive-foreground': '#ffffff',
    border: '#dfe6e9',
    input: '#dfe6e9',
    ring: '#ff00c8',
    'chart-1': '#ff00c8',
    'chart-2': '#9000ff',
    'chart-3': '#00e5ff',
    'chart-4': '#00ffcc',
    'chart-5': '#ffe600',
    radius: '0.5rem',
    sidebar: '#f0f0ff',
    'sidebar-foreground': '#0c0c1d',
    'sidebar-primary': '#ff00c8',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#00ffcc',
    'sidebar-accent-foreground': '#0c0c1d',
    'sidebar-border': '#dfe6e9',
    'sidebar-ring': '#ff00c8',
  },
  'pastel-dreams': {
    background: '#f7f3f9',
    foreground: '#374151',
    card: '#ffffff',
    'card-foreground': '#374151',
    popover: '#ffffff',
    'popover-foreground': '#374151',
    primary: '#a78bfa',
    'primary-foreground': '#ffffff',
    secondary: '#e9d8fd',
    'secondary-foreground': '#4b5563',
    muted: '#f3e8ff',
    'muted-foreground': '#6b7280',
    accent: '#f3e5f5',
    'accent-foreground': '#374151',
    destructive: '#fca5a5',
    'destructive-foreground': '#ffffff',
    border: '#e9d8fd',
    input: '#e9d8fd',
    ring: '#a78bfa',
    'chart-1': '#a78bfa',
    'chart-2': '#8b5cf6',
    'chart-3': '#7c3aed',
    'chart-4': '#6d28d9',
    'chart-5': '#5b21b6',
    radius: '1.5rem',
    sidebar: '#e9d8fd',
    'sidebar-foreground': '#374151',
    'sidebar-primary': '#a78bfa',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#f3e5f5',
    'sidebar-accent-foreground': '#374151',
    'sidebar-border': '#e9d8fd',
    'sidebar-ring': '#a78bfa',
  },
  'clean-slate': {
    background: '#f8fafc',
    foreground: '#1e293b',
    card: '#ffffff',
    'card-foreground': '#1e293b',
    popover: '#ffffff',
    'popover-foreground': '#1e293b',
    primary: '#6366f1',
    'primary-foreground': '#ffffff',
    secondary: '#e5e7eb',
    'secondary-foreground': '#374151',
    muted: '#f3f4f6',
    'muted-foreground': '#6b7280',
    accent: '#e0e7ff',
    'accent-foreground': '#374151',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#d1d5db',
    input: '#d1d5db',
    ring: '#6366f1',
    'chart-1': '#6366f1',
    'chart-2': '#4f46e5',
    'chart-3': '#4338ca',
    'chart-4': '#3730a3',
    'chart-5': '#312e81',
    radius: '0.5rem',
    sidebar: '#f3f4f6',
    'sidebar-foreground': '#1e293b',
    'sidebar-primary': '#6366f1',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#e0e7ff',
    'sidebar-accent-foreground': '#374151',
    'sidebar-border': '#d1d5db',
    'sidebar-ring': '#6366f1',
  },
  caffeine: {
    background: '#f9f9f9',
    foreground: '#202020',
    card: '#fcfcfc',
    'card-foreground': '#202020',
    popover: '#fcfcfc',
    'popover-foreground': '#202020',
    primary: '#644a40',
    'primary-foreground': '#ffffff',
    secondary: '#ffdfb5',
    'secondary-foreground': '#582d1d',
    muted: '#efefef',
    'muted-foreground': '#646464',
    accent: '#e8e8e8',
    'accent-foreground': '#202020',
    destructive: '#e54d2e',
    'destructive-foreground': '#ffffff',
    border: '#d8d8d8',
    input: '#d8d8d8',
    ring: '#644a40',
    'chart-1': '#644a40',
    'chart-2': '#ffdfb5',
    'chart-3': '#e8e8e8',
    'chart-4': '#ffe6c4',
    'chart-5': '#66493e',
    sidebar: '#fbfbfb',
    'sidebar-foreground': '#252525',
    'sidebar-primary': '#343434',
    'sidebar-primary-foreground': '#fbfbfb',
    'sidebar-accent': '#f7f7f7',
    'sidebar-accent-foreground': '#343434',
    'sidebar-border': '#ebebeb',
    'sidebar-ring': '#b5b5b5',
    radius: '0.5rem',
  },
  'ocean-breeze': {
    background: '#f0f8ff',
    foreground: '#374151',
    card: '#ffffff',
    'card-foreground': '#374151',
    popover: '#ffffff',
    'popover-foreground': '#374151',
    primary: '#22c55e',
    'primary-foreground': '#ffffff',
    secondary: '#e0f2fe',
    'secondary-foreground': '#4b5563',
    muted: '#f3f4f6',
    'muted-foreground': '#6b7280',
    accent: '#d1fae5',
    'accent-foreground': '#374151',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#e5e7eb',
    input: '#e5e7eb',
    ring: '#22c55e',
    'chart-1': '#22c55e',
    'chart-2': '#10b981',
    'chart-3': '#059669',
    'chart-4': '#047857',
    'chart-5': '#065f46',
    radius: '0.5rem',
    sidebar: '#e0f2fe',
    'sidebar-foreground': '#374151',
    'sidebar-primary': '#22c55e',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#d1fae5',
    'sidebar-accent-foreground': '#374151',
    'sidebar-border': '#e5e7eb',
    'sidebar-ring': '#22c55e',
  },
  'retro-arcade': {
    background: '#fdf6e3',
    foreground: '#073642',
    card: '#eee8d5',
    'card-foreground': '#073642',
    popover: '#eee8d5',
    'popover-foreground': '#073642',
    primary: '#d33682',
    'primary-foreground': '#ffffff',
    secondary: '#2aa198',
    'secondary-foreground': '#ffffff',
    muted: '#93a1a1',
    'muted-foreground': '#073642',
    accent: '#cb4b16',
    'accent-foreground': '#ffffff',
    destructive: '#dc322f',
    'destructive-foreground': '#ffffff',
    border: '#839496',
    input: '#839496',
    ring: '#d33682',
    'chart-1': '#268bd2',
    'chart-2': '#2aa198',
    'chart-3': '#d33682',
    'chart-4': '#cb4b16',
    'chart-5': '#dc322f',
    radius: '0.25rem',
    sidebar: '#fdf6e3',
    'sidebar-foreground': '#073642',
    'sidebar-primary': '#d33682',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#2aa198',
    'sidebar-accent-foreground': '#ffffff',
    'sidebar-border': '#839496',
    'sidebar-ring': '#d33682',
  },
  'midnight-bloom': {
    background: '#f9f9f9',
    foreground: '#333333',
    card: '#ffffff',
    'card-foreground': '#333333',
    popover: '#ffffff',
    'popover-foreground': '#333333',
    primary: '#6c5ce7',
    'primary-foreground': '#ffffff',
    secondary: '#a1c9f2',
    'secondary-foreground': '#333333',
    muted: '#c9c4b5',
    'muted-foreground': '#6e6e6e',
    accent: '#8b9467',
    'accent-foreground': '#ffffff',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#d4d4d4',
    input: '#d4d4d4',
    ring: '#6c5ce7',
    'chart-1': '#6c5ce7',
    'chart-2': '#8e44ad',
    'chart-3': '#4b0082',
    'chart-4': '#6495ed',
    'chart-5': '#4682b4',
    radius: '0.5rem',
    sidebar: '#f9f9f9',
    'sidebar-foreground': '#333333',
    'sidebar-primary': '#6c5ce7',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#8b9467',
    'sidebar-accent-foreground': '#ffffff',
    'sidebar-border': '#d4d4d4',
    'sidebar-ring': '#6c5ce7',
  },
  candyland: {
    background: '#f7f9fa',
    foreground: '#333333',
    card: '#ffffff',
    'card-foreground': '#333333',
    popover: '#ffffff',
    'popover-foreground': '#333333',
    primary: '#ffc0cb',
    'primary-foreground': '#000000',
    secondary: '#87ceeb',
    'secondary-foreground': '#000000',
    muted: '#ddd9c4',
    'muted-foreground': '#6e6e6e',
    accent: '#ffff00',
    'accent-foreground': '#000000',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#d4d4d4',
    input: '#d4d4d4',
    ring: '#ffc0cb',
    'chart-1': '#ffc0cb',
    'chart-2': '#87ceeb',
    'chart-3': '#ffff00',
    'chart-4': '#ff99cc',
    'chart-5': '#33cc33',
    radius: '0.5rem',
    sidebar: '#f7f9fa',
    'sidebar-foreground': '#333333',
    'sidebar-primary': '#ffc0cb',
    'sidebar-primary-foreground': '#000000',
    'sidebar-accent': '#ffff00',
    'sidebar-accent-foreground': '#000000',
    'sidebar-border': '#d4d4d4',
    'sidebar-ring': '#ffc0cb',
  },
  'northern-lights': {
    background: '#f9f9fa',
    foreground: '#333333',
    card: '#ffffff',
    'card-foreground': '#333333',
    popover: '#ffffff',
    'popover-foreground': '#333333',
    primary: '#34a85a',
    'primary-foreground': '#ffffff',
    secondary: '#6495ed',
    'secondary-foreground': '#ffffff',
    muted: '#ddd9c4',
    'muted-foreground': '#6e6e6e',
    accent: '#66d9ef',
    'accent-foreground': '#333333',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#d4d4d4',
    input: '#d4d4d4',
    ring: '#34a85a',
    'chart-1': '#34a85a',
    'chart-2': '#6495ed',
    'chart-3': '#66d9ef',
    'chart-4': '#4682b4',
    'chart-5': '#1a9641',
    radius: '0.5rem',
    sidebar: '#f9f9fa',
    'sidebar-foreground': '#333333',
    'sidebar-primary': '#34a85a',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#66d9ef',
    'sidebar-accent-foreground': '#333333',
    'sidebar-border': '#d4d4d4',
    'sidebar-ring': '#34a85a',
  },
  'vintage-paper': {
    background: '#f5f1e6',
    foreground: '#4a3f35',
    card: '#fffcf5',
    'card-foreground': '#4a3f35',
    popover: '#fffcf5',
    'popover-foreground': '#4a3f35',
    primary: '#a67c52',
    'primary-foreground': '#ffffff',
    secondary: '#e2d8c3',
    'secondary-foreground': '#5c4d3f',
    muted: '#ece5d8',
    'muted-foreground': '#7d6b56',
    accent: '#d4c8aa',
    'accent-foreground': '#4a3f35',
    destructive: '#b54a35',
    'destructive-foreground': '#ffffff',
    border: '#dbd0ba',
    input: '#dbd0ba',
    ring: '#a67c52',
    'chart-1': '#a67c52',
    'chart-2': '#8d6e4c',
    'chart-3': '#735a3a',
    'chart-4': '#b3906f',
    'chart-5': '#c0a080',
    radius: '0.25rem',
    sidebar: '#ece5d8',
    'sidebar-foreground': '#4a3f35',
    'sidebar-primary': '#a67c52',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#d4c8aa',
    'sidebar-accent-foreground': '#4a3f35',
    'sidebar-border': '#dbd0ba',
    'sidebar-ring': '#a67c52',
  },
  'sunset-horizon': {
    background: '#fff9f5',
    foreground: '#3d3436',
    card: '#ffffff',
    'card-foreground': '#3d3436',
    popover: '#ffffff',
    'popover-foreground': '#3d3436',
    primary: '#ff7e5f',
    'primary-foreground': '#ffffff',
    secondary: '#ffedea',
    'secondary-foreground': '#b35340',
    muted: '#fff0eb',
    'muted-foreground': '#78716C',
    accent: '#feb47b',
    'accent-foreground': '#3d3436',
    destructive: '#e63946',
    'destructive-foreground': '#ffffff',
    border: '#ffe0d6',
    input: '#ffe0d6',
    ring: '#ff7e5f',
    'chart-1': '#ff7e5f',
    'chart-2': '#feb47b',
    'chart-3': '#ffcaa7',
    'chart-4': '#ffad8f',
    'chart-5': '#ce6a57',
    radius: '0.625rem',
    sidebar: '#fff0eb',
    'sidebar-foreground': '#3d3436',
    'sidebar-primary': '#ff7e5f',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#feb47b',
    'sidebar-accent-foreground': '#3d3436',
    'sidebar-border': '#ffe0d6',
    'sidebar-ring': '#ff7e5f',
  },
  'starry-night': {
    background: '#f5f7fa',
    foreground: '#1a2238',
    card: '#e3eaf2',
    'card-foreground': '#1a2238',
    popover: '#fffbe6',
    'popover-foreground': '#1a2238',
    primary: '#3a5ba0',
    'primary-foreground': '#fffbe6',
    secondary: '#f7c873',
    'secondary-foreground': '#1a2238',
    muted: '#e5e5df',
    'muted-foreground': '#3a5ba0',
    accent: '#6ea3c1',
    'accent-foreground': '#fffbe6',
    destructive: '#2d1e2f',
    'destructive-foreground': '#fffbe6',
    border: '#b0b8c1',
    input: '#6ea3c1',
    ring: '#f7c873',
    'chart-1': '#3a5ba0',
    'chart-2': '#f7c873',
    'chart-3': '#6ea3c1',
    'chart-4': '#b0b8c1',
    'chart-5': '#2d1e2f',
    sidebar: '#e3eaf2',
    'sidebar-foreground': '#1a2238',
    'sidebar-primary': '#3a5ba0',
    'sidebar-primary-foreground': '#fffbe6',
    'sidebar-accent': '#f7c873',
    'sidebar-accent-foreground': '#1a2238',
    'sidebar-border': '#b0b8c1',
    'sidebar-ring': '#f7c873',
    radius: '0.5rem',
  },
  claude: {
    background: '#faf9f5',
    foreground: '#3d3929',
    card: '#faf9f5',
    'card-foreground': '#141413',
    popover: '#ffffff',
    'popover-foreground': '#28261b',
    primary: '#c96442',
    'primary-foreground': '#ffffff',
    secondary: '#e9e6dc',
    'secondary-foreground': '#535146',
    muted: '#ede9de',
    'muted-foreground': '#83827d',
    accent: '#e9e6dc',
    'accent-foreground': '#28261b',
    destructive: '#141413',
    'destructive-foreground': '#ffffff',
    border: '#dad9d4',
    input: '#b4b2a7',
    ring: '#c96442',
    'chart-1': '#b05730',
    'chart-2': '#9c87f5',
    'chart-3': '#ded8c4',
    'chart-4': '#dbd3f0',
    'chart-5': '#b4552d',
    sidebar: '#f5f4ee',
    'sidebar-foreground': '#3d3d3a',
    'sidebar-primary': '#c96442',
    'sidebar-primary-foreground': '#fbfbfb',
    'sidebar-accent': '#e9e6dc',
    'sidebar-accent-foreground': '#343434',
    'sidebar-border': '#ebebeb',
    'sidebar-ring': '#b5b5b5',
    radius: '0.5rem',
  },
  vercel: {
    background: 'oklch(0.99 0 0)',
    foreground: 'oklch(0 0 0)',
    card: 'oklch(1.00 0 0)',
    'card-foreground': 'oklch(0 0 0)',
    popover: 'oklch(0.99 0 0)',
    'popover-foreground': 'oklch(0 0 0)',
    primary: 'oklch(0 0 0)',
    'primary-foreground': 'oklch(1.00 0 0)',
    secondary: 'oklch(0.94 0 0)',
    'secondary-foreground': 'oklch(0 0 0)',
    muted: 'oklch(0.97 0 0)',
    'muted-foreground': 'oklch(0.44 0 0)',
    accent: 'oklch(0.94 0 0)',
    'accent-foreground': 'oklch(0 0 0)',
    destructive: 'oklch(0.63 0.19 23.03)',
    'destructive-foreground': 'oklch(1.00 0 0)',
    border: 'oklch(0.92 0 0)',
    input: 'oklch(0.94 0 0)',
    ring: 'oklch(0 0 0)',
    'chart-1': 'oklch(0.81 0.17 75.35)',
    'chart-2': 'oklch(0.55 0.22 264.53)',
    'chart-3': 'oklch(0.72 0 0)',
    'chart-4': 'oklch(0.92 0 0)',
    'chart-5': 'oklch(0.56 0 0)',
    sidebar: 'oklch(0.99 0 0)',
    'sidebar-foreground': 'oklch(0 0 0)',
    'sidebar-primary': 'oklch(0 0 0)',
    'sidebar-primary-foreground': 'oklch(1.00 0 0)',
    'sidebar-accent': 'oklch(0.94 0 0)',
    'sidebar-accent-foreground': 'oklch(0 0 0)',
    'sidebar-border': 'oklch(0.94 0 0)',
    'sidebar-ring': 'oklch(0 0 0)',
    radius: '0.5rem',
  },
  darkmatter: {
    background: '#ffffff',
    foreground: '#111827',
    card: '#ffffff',
    'card-foreground': '#111827',
    popover: '#ffffff',
    'popover-foreground': '#111827',
    primary: '#d87943',
    'primary-foreground': '#ffffff',
    secondary: '#527575',
    'secondary-foreground': '#ffffff',
    muted: '#f3f4f6',
    'muted-foreground': '#6b7280',
    accent: '#eeeeee',
    'accent-foreground': '#111827',
    destructive: '#ef4444',
    'destructive-foreground': '#fafafa',
    border: '#e5e7eb',
    input: '#e5e7eb',
    ring: '#d87943',
    'chart-1': '#5f8787',
    'chart-2': '#e78a53',
    'chart-3': '#fbcb97',
    'chart-4': '#888888',
    'chart-5': '#999999',
    sidebar: '#f3f4f6',
    'sidebar-foreground': '#111827',
    'sidebar-primary': '#d87943',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#ffffff',
    'sidebar-accent-foreground': '#111827',
    'sidebar-border': '#e5e7eb',
    'sidebar-ring': '#d87943',
    radius: '0.75rem',
  },
  mono: {
    background: '#ffffff',
    foreground: '#0a0a0a',
    card: '#ffffff',
    'card-foreground': '#0a0a0a',
    popover: '#ffffff',
    'popover-foreground': '#0a0a0a',
    primary: '#737373',
    'primary-foreground': '#fafafa',
    secondary: '#f5f5f5',
    'secondary-foreground': '#171717',
    muted: '#f5f5f5',
    'muted-foreground': '#717171',
    accent: '#f5f5f5',
    'accent-foreground': '#171717',
    destructive: '#e7000b',
    'destructive-foreground': '#f5f5f5',
    border: '#e5e5e5',
    input: '#e5e5e5',
    ring: '#a1a1a1',
    'chart-1': '#737373',
    'chart-2': '#737373',
    'chart-3': '#737373',
    'chart-4': '#737373',
    'chart-5': '#737373',
    sidebar: '#fafafa',
    'sidebar-foreground': '#0a0a0a',
    'sidebar-primary': '#171717',
    'sidebar-primary-foreground': '#fafafa',
    'sidebar-accent': '#f5f5f5',
    'sidebar-accent-foreground': '#171717',
    'sidebar-border': '#e5e5e5',
    'sidebar-ring': '#a1a1a1',
    radius: '0rem',
  },
  'soft-pop': {
    background: '#f7f9f3',
    foreground: '#000000',
    card: '#ffffff',
    'card-foreground': '#000000',
    popover: '#ffffff',
    'popover-foreground': '#000000',
    primary: '#4f46e5',
    'primary-foreground': '#ffffff',
    secondary: '#14b8a6',
    'secondary-foreground': '#ffffff',
    muted: '#f0f0f0',
    'muted-foreground': '#333333',
    accent: '#f59e0b',
    'accent-foreground': '#000000',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    border: '#000000',
    input: '#737373',
    ring: '#a5b4fc',
    'chart-1': '#4f46e5',
    'chart-2': '#14b8a6',
    'chart-3': '#f59e0b',
    'chart-4': '#ec4899',
    'chart-5': '#22c55e',
    sidebar: '#f7f9f3',
    'sidebar-foreground': '#000000',
    'sidebar-primary': '#4f46e5',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#f59e0b',
    'sidebar-accent-foreground': '#000000',
    'sidebar-border': '#000000',
    'sidebar-ring': '#a5b4fc',
    radius: '1rem',
  },
  'sage-garden': {
    background: '#f8f7f4',
    foreground: '#1a1f2e',
    card: '#ffffff',
    'card-foreground': '#1a1f2e',
    popover: '#ffffff',
    'popover-foreground': '#1a1f2e',
    primary: '#7c9082',
    'primary-foreground': '#ffffff',
    secondary: '#ced4bf',
    'secondary-foreground': '#1a1f2e',
    muted: '#e8e6e1',
    'muted-foreground': '#6b7280',
    accent: '#bfc9bb',
    'accent-foreground': '#1a1f2e',
    destructive: '#c73e3a',
    'destructive-foreground': '#ffffff',
    border: '#e8e6e1',
    input: '#ffffff',
    ring: '#7c9082',
    'chart-1': '#7c9082',
    'chart-2': '#a0aa88',
    'chart-3': '#8b9d83',
    'chart-4': '#6b7280',
    'chart-5': '#e8e6e1',
    sidebar: '#fafaf8',
    'sidebar-foreground': '#1a1f2e',
    'sidebar-primary': '#7c9082',
    'sidebar-primary-foreground': '#ffffff',
    'sidebar-accent': '#e8e6e1',
    'sidebar-accent-foreground': '#1a1f2e',
    'sidebar-border': '#e8e6e1',
    'sidebar-ring': '#7c9082',
    radius: '0.35rem',
  },
};

export const PRESET_CSS_VAR_KEYS: string[] = Object.keys(
  Object.values(PRESETS_LIGHT)[0],
);
